import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { createEntitySlice, EntityState, getAllRequest, serializeAxiosError } from '../shared/reducers/reducer.utils';
import { cleanEntity } from '../shared/util/entity-utils/entity-utils';

const apiUrl = 'api/profase-workflow-empresa-disenos';

function extractErrorMessage(error: any, fallback: string): string {
    const data = error?.response?.data;
    return data?.detail ?? data?.message ?? data?.title ?? error?.message ?? fallback;
}

export const updateDiseno = createAsyncThunk(
    'workflowEmpresaDiseno/update_entity',
    async (entity: any) => {
        return axios.put<any>(`${apiUrl}/${entity.id}`, cleanEntity(entity));
    },
    { serializeError: serializeAxiosError },
);

export const getEntities = createAsyncThunk(
    'workflowEmpresaDiseno/fetch_entity_list',
    async (request: any) => {
        const params = getAllRequest(request);
        const requestUrl = `${apiUrl}?${params}&cacheBuster=${new Date().getTime()}`;
        return axios.get<any[]>(requestUrl);
    },
    { serializeError: serializeAxiosError },
);

export const WorkflowEmpresaDisenoSlice = createEntitySlice({
    name: 'workflowEmpresaDiseno',
    skipRejectionHandling: true,
    initialState: {
        loading: false,
        errorMessage: null,
        entities: [],
        entity: {},
        updating: false,
        totalItems: 0,
        updateSuccess: false,
    } as EntityState<any>,
    extraReducers(builder) {
        builder
            .addMatcher(isFulfilled(getEntities), (state, action) => {
                const { data, headers } = action.payload;
                return {
                    ...state,
                    loading: false,
                    entities: data,
                    totalItems: parseInt(headers['x-total-count'], 10),
                };
            })
            .addMatcher(isFulfilled(updateDiseno), (state, action) => {
                state.updating = false;
                state.loading = false;
                state.updateSuccess = true;
                state.entity = action.payload.data;
            })
            .addMatcher(isPending(getEntities), state => {
                state.errorMessage = null;
                state.updateSuccess = false;
                state.loading = true;
            })
            .addMatcher(isRejected(getEntities), (state, action) => {
                state.loading = false;
                state.errorMessage = extractErrorMessage(action.error, 'Error al cargar los datos');
            })
            .addMatcher(isRejected(updateDiseno), (state, action) => {
                state.updating = false;
                state.loading = false;
                state.updateSuccess = false;
                state.errorMessage = extractErrorMessage(action.error, 'Error al procesar la solicitud');
            });
    },
});

export const { reset } = WorkflowEmpresaDisenoSlice.actions;
export default WorkflowEmpresaDisenoSlice.reducer;
